// @ts-nocheck
import React, { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';

import { REGION } from '../../const/config';
import { menuright } from '../../utils/constants';
import { menuList } from './menu-list';

import './common.styl';
import './MainMenu.styl';

import {
  createPostByEntity,
  createTheme,
  tryReportCount,
} from '../../actions/actions';

const actionMenueClasses = {
	'ca': 'MainMenuBgCa',
	'by': 'MainMenuBgBy',
}
const actionMenuBg = actionMenueClasses[REGION] || actionMenuBg;

const FETCH_TIMER = 30 * 1000;

const MenuItemLink = ({
  route,
  index,
  title,
  icon,
  caption,
  extraClass,
  isLinkActive,
  counter,
}) => (
  <Link
    title={title}
    key={route + index}
    to={route}
    className={['item', extraClass, isLinkActive ? 'active' : ''].join(' ')}
  >
    {icon ? <i className={icon} /> : null}
    {caption ? caption : route == '/reports' ? counter : null}
  </Link>
);

const MainMenu = () => {

  // State connect
  const user_id = useSelector((state) => state.user.userId);
  const reportCount = useSelector((state) => state.reportCount);
  const userRoles = useSelector((state) => state.user.user.roles);
  const pathname = useSelector(state => state.routing.locationBeforeTransitions.pathname);
  const currentType = useMemo(() => {
    if (!pathname) return null;
    return pathname.split('/')[1];
  }, [pathname]);

  // Filter menu and submenu
  // if item has not regions or roles, it will be shown
  // if item has regions, it will be shown only if user has this region
  // if item has roles, it will be shown only if user has this role
  // if item has regions and roles, it will be shown only if user has this region and role
  const filterByRegionAndRoles = (item) => {
    return (
      (item.regions === undefined || item?.regions?.length === 0 || item?.regions?.includes(REGION)) &&
      (item.roles === undefined || item?.roles?.length === 0 || (userRoles && item?.roles?.some(role => userRoles.includes(role))))
    );
  };
  const menu = useMemo(() => {
    return menuList
      .filter(filterByRegionAndRoles)
      .map((obj, i) => {
        if (obj.submenu) {
          return {
            ...obj,
            submenu: obj.submenu.filter(filterByRegionAndRoles),
          };
        }
        return obj;
      });
  }, [userRoles]);

  // Array of refs for dropdowns
  const dropdownRefs = useRef([]);

  // Dispatch connect
  const dispatch = useDispatch();
  const createEntity = (type) => {
    if (type === 'theme') {
      dispatch(createTheme());
    } else {
      dispatch(createPostByEntity(type));
    }
  };
  const getReportCount = () => {
    dispatch(tryReportCount());
  };

  // ComponentDidMount here
  useEffect(() => {
    dropdownRefs
      .current
      .filter(Boolean)
      .forEach((dropdown) => {
        if (dropdown) {
          $(dropdown).dropdown();
        }
      });

    // Call getReportCount every FETCH_TIMER
    getReportCount();
    const timer = setInterval(() => getReportCount(), FETCH_TIMER);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={`${actionMenuBg} MainMenu ui inverted borderless menu`}>
      {/* LOGO */}
      <Link to="/" className="header item">
        МЗ
      </Link>

      {/* MAIN LINE */}
      {
        menu.map((obj, i) => {
          if (obj.submenu) {
            return (<div className="item" title="новая публикация">
              <div
                className="ui dropdown meta-menu-open icon js-publication-dropdown"
                tabIndex="-1"
                title={obj.title}
                key={obj.route + i}
                ref={el => dropdownRefs.current[i] = el}
              >
                <i className="icon suitcase" tabIndex="-1" style={{ margin: 0 }} />
                <i className="icon dropdown" tabIndex="-1" style={{ margin: 0 }} />
                <div className="menu" tabIndex="-1">
                  {
                    obj.submenu.map((subitem, j) => {
                      const { caption, title, route, icon } = subitem;
                      return MenuItemLink({
                        caption,
                        title,
                        route,
                        icon,
                        needText: true,
                        index: i*100+j,
                        extraClass: 'icon-black',
                        isLinkActive: false,
                      });
                    })
                  }
                </div>
              </div>
            </div>)
          }
          return MenuItemLink({
            ...obj,
            index: i,
            isLinkActive: obj.route === `/${currentType}`,
            counter: reportCount,
          });
        })
      }

      {/* RIGHT LINE */}
      <div className="right menu">
        <div className="item" title="добавить новость">
          <div
            className="newPost ui grey circular link button"
            data-format="news"
            onClick={() => createEntity('news')}
          >
            Новость
          </div>
        </div>
        <div className="item" title="новая публикация">
          <div
            className="newPost ui grey circular dropdown meta-menu-open icon button js-publication-dropdown"
            tabIndex="-1"
            ref={el => dropdownRefs.current[0] = el}
          >
            Публикация &nbsp;
            <i className="icon dropdown" tabIndex="-1">
              <div className="menu" tabIndex="-1" />
            </i>
            <div className="menu" tabIndex="-1">
              {menuright
                .filter(item => item.regions.includes(REGION))
                .map(({ key, title }) => (
                  <div
                    className="newPost link item"
                    onClick={() => createEntity(key)}
                    key={key}
                    data-format={key}
                  >
                    {title}
                  </div>
                ))
              }
            </div>
          </div>
        </div>
        <MenuItemLink
          route={`/users/${user_id}`}
          title="ваш аккаунт"
          icon="user icon"
          extraClass="ui icon inverted basic circular button user-button"
          isLinkActive={currentType === 'users'}
        />
      </div>
    </div>
  )
};

export default MainMenu;
